package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("CreateNewPublicPlanResponse")
data class CreateNewPublicPlanResponse(
    @JsName("globalEntryId")
    val globalEntryId: String,

    @JsName("websiteLink")
    val websiteLink: String,

    @JsName("qrCodeUri")
    val qrCodeUri: String,

    @JsName("accessCode")
    val accessCode: String,

    @JsName("success")
    val success: Boolean,

    @JsName("message")
    val message: String? = null
)